import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (() => Promise<void>) | null;
  contentText: string;
  confirmText: string;
  closeText: string;
  dialogTitle: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ open, onClose, onConfirm, contentText, confirmText, closeText, dialogTitle }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ backgroundColor: "var(--primary-color)", color: "var(--aggrid-text-color)",marginBottom:'8px' }}> {dialogTitle}</DialogTitle>
      <DialogContent >
        <DialogContentText>
          <div dangerouslySetInnerHTML={{ __html: contentText }} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={async () => { if (onConfirm) await onConfirm(); }} color="secondary">
          {confirmText}
        </Button>
        <Button onClick={onClose} color="primary">
          {closeText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
